const Theme = {
  savePreviewImage: (memorialId) => ({
    url: `/memorial/preview-image/${memorialId}`,
    method: "PUT",
  }),
  reportMemorial: {
    url: "/report",
    method: "POST",
  },
  updateCommentStatus: (commentId) => ({
    url: `/memorial/comment-status/${commentId}`,
    method: "PUT",
  }),
  getReportCategory: {
    url: "/report-category",
    method: "GET",
  },
  getLocations: (id) => ({
    url: `/memorial/${id}/map-view`,
    method: "GET",
  }),
  saveUnSaveBiography: (memorialId) => ({
    url: `/save-biography/${memorialId}`,
    method: "POST",
  }),
  getFamilyTree: (memorialId) => ({
    url: `/memorial/family/${memorialId}`,
    method: "GET",
  }),

  getPaternalTree: (memorialId) => ({
    url: `/memorial/paternal-tree/${memorialId}`,
    method: "GET",
  }),
  getScreenShot: (memorialId) => ({
    url: `/memorial/${memorialId}/screenshot`,
    method: "GET",
  }),
};
export default Theme;
